import { MapPin } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { BR_STATES } from "@/lib/brStates";

export const StateFilter = ({ value, onChange, testId = "state-filter" }) => {
  return (
    <div className="flex items-center gap-3">
      <span className="hidden sm:flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase text-[#C6A762]">
        <MapPin size={13} /> Filtrar por estado
      </span>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          data-testid={testId}
          className="w-full sm:w-[240px] h-11 bg-[#141414] border-[#262626] text-white/90 text-sm rounded-lg focus:ring-[#C6A762]/40 hover:border-[#C6A762]/50 transition-colors"
        >
          <SelectValue placeholder="Todos os estados" />
        </SelectTrigger>
        <SelectContent className="bg-[#141414] border-[#262626] text-white/90 max-h-72">
          <SelectItem value="all" data-testid={`${testId}-option-all`}>
            Todos os estados
          </SelectItem>
          {BR_STATES.map((s) => (
            <SelectItem key={s.uf} value={s.uf} data-testid={`${testId}-option-${s.uf}`}>
              {s.name} ({s.uf})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default StateFilter;
